import { useQuery } from "@tanstack/react-query";
import {
  POST_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO,
  POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH,
  POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW,
  POST_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO,
  POST_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO,
  POST_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO,
  POST_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO,
  POST_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO,
  POST_SPONSORED_COMMUNITY_COMMENTS_INFO,
  POST_SPONSORED_COMMUNITY_CONTENT_INFO,
  POST_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS,
  POST_SPONSORED_COMMUNITY_DASHBOARD_INFO,
  POST_SPONSORED_COMMUNITY_REACH,
  POST_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT,
} from "../../../api/endpoints/sponsored-community-endpoints";
import axiosInstance from "../../../api/instances/axiosInstance";
import {
  KEY_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO,
  KEY_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO,
  KEY_SPONSORED_COMMUNITY_COMMENTS_INFO,
  KEY_SPONSORED_COMMUNITY_CONTENT_INFO,
  KEY_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS,
  KEY_SPONSORED_COMMUNITY_DASHBOARD_INFO,
  KEY_SPONSORED_COMMUNITY_REACH,
  KEY_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT,
} from "../../query-constants/workspace/sponsored-community-constant";

const staleTime = 300000;
const cacheTime = 600000;

export const useGetDashboardInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_DASHBOARD_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_DASHBOARD_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetContentInfo = (project_id, payload, enabled) => {
  return useQuery(
    [KEY_SPONSORED_COMMUNITY_CONTENT_INFO, project_id, JSON.stringify(payload)],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_CONTENT_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetLocationInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetContentView = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetContentReach = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetZoneInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetDeviceInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetMobileDeviceInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetBrowserInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetCommentsInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_COMMENTS_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_COMMENTS_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetContentViewsAndReach = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetCommunityReach = (project_id, payload, enabled) => {
  return useQuery(
    [KEY_SPONSORED_COMMUNITY_REACH, project_id, JSON.stringify(payload)],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_REACH}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetSpecialityInfo = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};

export const useGetSubscribersCount = (project_id, payload, enabled) => {
  return useQuery(
    [
      KEY_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT,
      project_id,
      JSON.stringify(payload),
    ],
    () =>
      axiosInstance.post(
        `project/${project_id}/${POST_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT}`,
        payload
      ),
    {
      enabled: enabled,
      refetchOnWindowFocus: false,
      cacheTime,
      staleTime,

      select: (res) => res?.data?.data ?? [],
    }
  );
};
